export enum ActionTypes {
  GET_ARTIST = 'GET_ARTIST',
  GET_ARTIST_LIST = 'GET_ARTIST_LIST',

  GET_GENRE = 'GET_GENRE',
  GET_GENRE_LIST = 'GET_GENRE_LIST',

  GET_SELECTION = 'GET_SELECTION',
  GET_SELECTION_LIST = 'GET_SELECTION_LIST',

  GET_SERIES = 'GET_SERIES',
  GET_SERIES_CONTENT = 'GET_SERIES_CONTENT',
  GET_SERIES_LIST = 'GET_SERIES_LIST',

  GET_YEARBEST = 'GET_YEARBEST',
  GET_YEARBEST_LIST = 'GET_YEARBEST_LIST',

  GET_WORK = 'GET_WORK',
  GET_WORK_LIST = 'GET_WORK_LIST',

  PREPARE_ARTIST_PAGE = 'PREPARE_ARTIST_PAGE',
  PREPARE_GENRE_PAGE = 'PREPARE_GENRE_PAGE',
  PREPARE_SERIES_PAGE = 'PREPAGE_SERIES_PAGE',
  PREPARE_WORK_PAGE = 'PREPARE_WORK_PAGE',

  TOP_TOPIC = 'TOP_TOPIC',
}
